import { render, staticRenderFns } from "./adsSelector.vue?vue&type=template&id=317daa85&scoped=true"
import script from "./adsSelector.vue?vue&type=script&lang=js"
export * from "./adsSelector.vue?vue&type=script&lang=js"
import style0 from "./adsSelector.vue?vue&type=style&index=0&id=317daa85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317daa85",
  null
  
)

export default component.exports